import {
	RegistryPersonalInformation,
	RegistryEconomicInformation,
	RegistryBirthInformation,
	RegistryTaxInformation,
	RegistryOfficialAddress
} from '@/gql/graphql';

type PersonalInformationKeys = Exclude<keyof RegistryPersonalInformation, '__typename'>;

export const RegistryPersonalInformationKeys: Record<
	PersonalInformationKeys,
	PersonalInformationKeys
> = {
	name: 'name',
	firstLastName: 'firstLastName',
	secondLastName: 'secondLastName',
	curp: 'curp',
	maritalStatus: 'maritalStatus',
	hasChildren: 'hasChildren'
} as const;

type EconomicInformationKeys = Exclude<keyof RegistryEconomicInformation, '__typename'>;

export const RegistryEconomicInformationKeys: Record<
	EconomicInformationKeys,
	EconomicInformationKeys
> = {
	occupation: 'occupation',
	extraMonthlyIncome: 'extraMonthlyIncome',
	monthlyFamilyExpense: 'monthlyFamilyExpense',
	monthlyFamilyIncome: 'monthlyFamilyIncome',
	houseType: 'houseType'
} as const;

type BirthInformationKeys = Exclude<keyof RegistryBirthInformation, '__typename'>;

export const RegistryBirthInformationKeys: Record<BirthInformationKeys, BirthInformationKeys> = {
	countryOfBirth: 'countryOfBirth',
	dateOfBirth: 'dateOfBirth',
	stateOfBirth: 'stateOfBirth',
	nationality: 'nationality'
} as const;

type TaxInformationKeys = Exclude<keyof RegistryTaxInformation, '__typename'>;

export const RegistryTaxInformationKeys: Record<TaxInformationKeys, TaxInformationKeys> = {
	rfc: 'rfc',
	clabe: 'clabe',
	eSignatureSerialNumber: 'eSignatureSerialNumber',
	officialIdType: 'officialIdType',
	taxRegimeCode: 'taxRegimeCode'
} as const;

type OfficialAddressKeys = Exclude<keyof RegistryOfficialAddress, '__typename'>;

export const RegistryOfficialAddressKeys: Record<OfficialAddressKeys, OfficialAddressKeys> = {
	city: 'city',
	colony: 'colony',
	externalNumber: 'externalNumber',
	internalNumber: 'internalNumber',
	municipalityOrDelegation: 'municipalityOrDelegation',
	postalCode: 'postalCode',
	state: 'state',
	street: 'street'
} as const;
